<div #chatboxParent [class.embedded-container]="isEmbedded">
  <!-- Debug: channel={{channel}}, embedded={{isEmbedded}}, mode={{widgetMode}} -->
  <crchat-chatwidget *ngIf='channel' id='chatbox' [channel]='channel' [attr.channel]='channel' version=''
                     [options]='options' [mode]='widgetMode' [apiUrl]='widgetApiUrl' [extensionService]='chatExtension'></crchat-chatwidget>
</div>
